import request from '@/utils/request';
//抽奖活动数据
export function getLotteryReport(values) {
  return request('/activityLottery/queryLotteryReport', {
    method: 'POST',
    data: values,
  });
}
